import {ApiClient} from './apiClient/apiClient';

const apiClient = new ApiClient();

export const getProfile = () => {
    return apiClient.get(`profile`);
}
